import { RISK_HEADERS } from '../RiskIndicatorConstants';
import { RiskIndicatorHeaders } from './TableComponents/RiskIndicatorHeaders';
import styles from '../RiskIndicators.module.scss';
import RiskIndicatorRows from './TableComponents/RiskIndicatorRows';
import { Row } from '../RiskIndicators';

const RiskIndicatorTable = ({
    rows,
    setRows,
    isPDFReport = false,
    onOpenRegulatoryRisk,
}: {
    rows: Row[];
    setRows: React.Dispatch<React.SetStateAction<Row[]>>;
    isPDFReport?: boolean;
    onOpenRegulatoryRisk?: (row: Row, checkType: string) => void;
}) => {
    return (
        <div className={styles.TableContainer} style={{ border: '0.031rem' }}>
            <div className={styles.TableHead}>
                <RiskIndicatorHeaders headers={RISK_HEADERS} />
            </div>
            <div className={styles.TableRows}>
                <RiskIndicatorRows
                    rows={rows}
                    setRows={setRows}
                    headers={RISK_HEADERS}
                    isPDFReport={isPDFReport}
                    onOpenRegulatoryRisk={onOpenRegulatoryRisk}
                />
            </div>
        </div>
    );
};

export default RiskIndicatorTable;
